export default "__VITE_ASSET__CseJ1_ey__$_?url__"